function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9201 -8164)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-9201 8164)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10798.896 7772.703)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2848.937 -2042.986)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4476.088,2451.343a10.866,10.866,0,0,0-1.025-3.846,11.255,11.255,0,0,0-4.817-5.117,11.584,11.584,0,0,0-5.142-1.392c-.207-.009-.275.046-.271.261q.013.778.008,1.556a9.479,9.479,0,1,1-9.488,9.479c0-.186.006-.37.016-.553-.513-.028-1.027-.058-1.541-.094-.221-.016-.287.04-.291.27a11.926,11.926,0,0,0,.465,3.538,11.276,11.276,0,0,0,11.683,8.1,11.291,11.291,0,0,0,10.4-12.2Z",
  transform: "translate(0 0)",
  fill: "#707070",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4465.808,2443.528c-.028-.516-.057-1.03-.076-1.545-.008-.221-.1-.259-.3-.243a11.1,11.1,0,0,0-3.68.956,11.352,11.352,0,0,0-6.542,8.7c-.028.184.017.26.223.281q.776.079,1.549.179A9.481,9.481,0,0,1,4465.808,2443.528Z",
  transform: "translate(-1.567 -0.706)",
  fill: "#71aff8",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3156.54 -2576.578)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4773.476,2985.213H4775c.276,0,.551-.005.827,0a.676.676,0,0,1,.433,1.235c-1.783,1.56-3.569,3.116-5.343,4.685a.688.688,0,0,1-1.128-.784q.568-1.312,1.133-2.627c.142-.329.284-.658.424-.988a1.55,1.55,0,0,0,.048-.167c-.087,0-.154-.012-.221-.012-.667,0-1.333,0-2,0a.823.823,0,0,1-.7-.248.668.668,0,0,1,.086-.974q.947-.829,1.9-1.654l3.513-3.074a.681.681,0,0,1,1.183.285.9.9,0,0,1-.066.518c-.495,1.179-1.005,2.352-1.51,3.527C4773.544,2985.013,4773.518,2985.1,4773.476,2985.213Z",
  transform: "translate(0 0)",
  fill: "#71aff8",
  fillRule: "evenodd"
}))));

function SvgIconTar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTar);
export default __webpack_public_path__ + "static/media/icon-tar.d7b2be60.svg";
export { ForwardRef as ReactComponent };